import { ASSET_TYPE } from '../config/const.config';

const validateFileType = (allowedExtensions, files) => {
  let errorMsg = '';

  for (let loop = 0; loop < files.length; loop += 1) {
    if (!allowedExtensions.exec(files[loop]?.name)) {
      errorMsg = 'Invalid file type selected.';
    }
  }

  return errorMsg || '';
};

const validateSelectedVideoFile = (
  selectedFiles = null,
  multiUpload = false
) => {
  let errorMsg = '';
  const files = selectedFiles;

  if (!files || files?.length === 0) {
    errorMsg = 'Please select video file to upload.';
  } else if (!multiUpload && files?.length > 1) {
    errorMsg = 'Single video file selection allowed.';
  }

  if (errorMsg === '') {
    const allowedExtensions = /(\.mp4|\.mov|\.wmv|\.flv|\.avi|\.mkv|\.webm)$/i;
    errorMsg = validateFileType(allowedExtensions, files);
  }

  return errorMsg || null;
};

const validateSelectedImageFile = (
  selectedFiles = null,
  multiUpload = false
) => {
  let errorMsg = '';
  const files = selectedFiles;

  if (!files || files?.length === 0) {
    errorMsg = 'Please select image file to upload.';
  } else if (!multiUpload && files?.length > 1) {
    errorMsg = 'Single image file selection allowed.';
  }

  if (errorMsg === '') {
    const allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif)$/i;
    errorMsg = validateFileType(allowedExtensions, files);
  }

  return errorMsg || null;
};

const validateFilesName = (files = [], languages = []) => {
  let errorMsg = '';

  for (let loop = 0; loop < files.length; loop += 1) {
    const fileName = files[loop]?.name?.toLowerCase();
    const parts = fileName.split('-');

    const language = parts[0];
    const type = parts[1];
    const extension = fileName.split('.').pop();

    // validate language
    if (!languages.some((lang) => lang.code === language)) {
      errorMsg = `Invalid language code in file: ${files[loop].name}`;
      break;
    }

    // validate asset type
    if (!['slide', 'audio', 'text'].includes(type)) {
      errorMsg = `Invalid asset type in file: ${files[loop].name}`;
      break;
    }

    // validate extension based on type
    if (type === 'slide' && extension !== 'pdf') {
      errorMsg = `Slides must be PDF: ${files[loop].name}`;
      break;
    }

    if (
      type === 'audio' &&
      !['mp3', 'aac', 'wav', 'flac'].includes(extension)
    ) {
      errorMsg = `Invalid audio format: ${files[loop].name}`;
      break;
    }

    if (type === 'text' && !['pdf', 'docx'].includes(extension)) {
      errorMsg = `Transcript must be PDF or DOCX: ${files[loop].name}`;
      break;
    }
  }

  return errorMsg || '';
};

const validateMultiUploadFiles = (files = [], languages = []) => {
  if (!files?.length) {
    return 'Please select pdf, mp3 or docx files to upload.';
  }

  const allowedExtensions = /\.(mp3|aac|wav|flac|pdf|docx)$/i;
  let errorMsg = validateFileType(allowedExtensions, files);
  if (errorMsg) return errorMsg;

  errorMsg = validateFilesName(files, languages);
  return errorMsg || null;
};

const getAssetTypeFromFile = (fileName) => {
  const name = fileName.toLowerCase();
  const parts = name.split('-');

  const type = parts[1];

  if (type === 'slide') {
    return ASSET_TYPE.SLIDES.value;
  }

  if (type === 'audio') {
    return ASSET_TYPE.PODCAST.value;
  }

  if (type === 'text') {
    const extension = name.split('.').pop();

    if (extension === 'pdf') {
      return ASSET_TYPE.TRANSCRIPT_PDF.value;
    }
    if (extension === 'docx') {
      return ASSET_TYPE.TRANSCRIPT_DOCX.value;
    }
  }

  return null;
};

const validateSelectedAssetFile = (files = null, allowedExtensions = '') => {
  let errorMsg = '';

  if (!files || files?.length === 0) {
    errorMsg = 'Please select file to upload.';
  } else if (files?.length > 1) {
    errorMsg = 'Single file selection allowed.';
  }
  if (errorMsg === '') {
    errorMsg = validateFileType(allowedExtensions, files);
  }

  return errorMsg || null;
};

export {
  validateSelectedVideoFile,
  validateSelectedImageFile,
  validateMultiUploadFiles,
  getAssetTypeFromFile,
  validateSelectedAssetFile,
};
